<template>
  <div class="page-container has-action">
    <van-nav-bar class="buying-navbar" :title="promData.name" fixed left-arrow @click-left="goableBack()" />
    <div class="buying">
      <div class="block">
        <div class="fs-18">竞买额</div>
        <template>
          <van-field class="tian-amount mt-10" type="number" v-model="amt" readonly>
            <div slot="left-icon">￥</div>
          </van-field>
        </template>
      </div>
      <div class="block mt-5">
        <div class="fs-18">支付方式</div>
        <van-radio-group class="mt-10" v-model="payType">
          <van-cell class="px-0">
            <van-radio slot="title" name="3" checked-color="#c7a673">
              <div>
                <div class="fs-16" style="line-height: 0.6rem">使用体验金{{amt}}元认购</div>
                <!-- <div class="color-gray-dark" style="line-height: 0.6rem">目前可用余额{{ balance | numFormat }}元
                                </div> -->
              </div>
            </van-radio>
          </van-cell>
        </van-radio-group>
      </div>
      <div class="block mt-5 color-gray-dark">
        “体验金收益红包”使用规则：您认购的新手体验金专享资产到期后即可收到“体验金收益红包”，您可在“我的优惠券”中查看并在认购其他相关资产时作为现金抵扣。
      </div>
    </div>

    <div class="page-action">
      <van-button :disabled="disabled" :loading="loading" loading-text="提交中..." class="buying-next-step" @click="onBuy" type="danger" size="large">购买</van-button>
    </div>
  </div>
</template>

<script>
import session from "@/utils/session";
import * as ProductApi from "@/api/product";
import { mapGetters } from 'vuex'

import {
  RadioGroup,
  Radio,
  Field,
  Icon,
} from "vant";

export default {
  components: {
    [RadioGroup.name]: RadioGroup,
    [Icon.name]: Icon,
    [Radio.name]: Radio,
    [Field.name]: Field,
  },

  data() {
    return {
      payType: "",
      promData: {},
      promCoupon: {},
      amt: "",
      disabled: true,
      loading: false
    };
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  beforeMount() {

    // 获得资产详情信息 
    ProductApi.getProm().then(data => {
      this.promData = data.list[0];
    });
    ProductApi.showProm({}).then(data => {
      if (data) {
        this.promCoupon = data;
        this.amt = parseInt(this.promCoupon.giveAmt / 100);
        this.disabled = false;
      } else {

        this.$toast({
          message: '没有体验金,请先领取',
          onClose: () => {
            this.$router.replace({ name: 'home' });
          }
        });
      }
    }).catch(err => {

    })
  },
  methods: {
    onBuy() {
      if (this.payType.length < 1) {
        this.$toast("请选择支付方式");
        return;
      }
      this.loading = true;
      ProductApi.buyProm(this.promCoupon.id).then(res => {
        this.loading = false;
        this.$toast(res);
        this.$router.replace({ path: '/investRecord' });
      }).catch(err => {
        this.loading = false;
        this.$toast(err.msg);
      })
    },
  }
};
</script>

<style scoped lang="less">
.page-container {
  padding-bottom: 110px;
}

// 没法使用 scoped , 否则会导致样式无法选中
.buying {
  ::v-deep .tian-amount {
    .van-field__left-icon {
      font-weight: 600;
    }

    .van-field__left-icon,
    .van-field__control {
      font-size: 32px;
      line-height: 36px;
    }
  }
}

.page-action {
  height: auto;

  ::v-deep .van-checkbox {
    padding: 10px 20px;
    // background: @gray-dark;
    background: white;
    font-size: 16px;

    .van-checkbox__label {
      color: #666666;
    }

    .van-checkbox__icon {
      position: relative;
      top: 1px;

      .van-icon {
        border-width: 1px;
      }
    }

    .page-action-arrow-up {
      position: absolute;
      top: 2px;
      right: 20px;
      padding: 10px;
    }
  }
}

.automatic-control {
  position: absolute;
  right: 20px;
  top: 12px;
  border: 1px solid #c1a76a;
  padding: 0 6px;
  color: #c1a76a;
}

.tian-amount {
  ::v-deep .van-field__control:disabled {
    color: inherit;
    -webkit-text-fill-color: inherit;
  }
}

.buying-title {
  text-align: center;
  font-size: 20px;
  color: #575e66;
  position: relative;
}

.limit-list {
  padding-top: 10px;

  .van-cell {
    padding-top: 0;
    padding-bottom: 0;
  }

  .van-cell__value {
    font-size: 12px;
  }
}

.cell-bank-card {
  .van-cell {
    padding-left: 30px;
  }
}
</style>
